import React from 'react';
import './Loader.css';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
  showLogo?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ 
  size = 'medium', 
  fullScreen = false,
  showLogo = true 
}) => {
  const sizeClass = `loader--${size}`;
  const fullScreenClass = fullScreen ? 'loader--fullscreen' : '';

  return (
    <div className={`loader-container ${fullScreenClass}`}>
      <div className={`loader ${sizeClass}`}>
        <div className="loader__spinner">
          <div className="loader__spinner-ring"></div>
          <div className="loader__spinner-ring loader__spinner-ring--delay"></div>
          {showLogo && (
            <div className="loader__logo">
              <img
                src={`${process.env.PUBLIC_URL}/branding/icon-logo.svg`}
                alt="Flypix"
                className="loader__logo-image loader__logo-image--light"
              />
              <img
                src={`${process.env.PUBLIC_URL}/branding/icon-logo.svg`}
                alt="Flypix"
                className="loader__logo-image loader__logo-image--dark"
              />
            </div>
          )}
        </div>
        {fullScreen && (
          <div className="loader__text">Загрузка...</div>
        )}
      </div>
    </div>
  );
};

export default Loader;
